//#region src/formatters/units.ts
var e = {
	day: "day",
	hour: "hour",
	minute: "minute",
	seconds: "seconds",
	value: "value",
	valueSingle: "valueSingle",
	percent: "percent",
	valuePerHour: "valuePerHour"
};
//#endregion
export { e as units };
